/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AccountActivationRouteImport } from './routes/account-activation'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as ProtectedSplatRouteImport } from './routes/_protected/$'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedMyProfileRouteImport } from './routes/_protected/my-profile'
import { Route as ProtectedNotificationsRouteImport } from './routes/_protected/notifications'
import { Route as ProtectedSplatIdRouteImport } from './routes/_protected/$/$id'
import { Route as ProtectedSplatAddRouteImport } from './routes/_protected/$/add'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountActivationRoute = AccountActivationRouteImport.update({
  id: '/account-activation',
  path: '/account-activation',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedSplatRoute = ProtectedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedMyProfileRoute = ProtectedMyProfileRouteImport.update({
  id: '/my-profile',
  path: '/my-profile',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedNotificationsRoute = ProtectedNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSplatIdRoute = ProtectedSplatIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProtectedSplatRoute,
} as any)
const ProtectedSplatAddRoute = ProtectedSplatAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => ProtectedSplatRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account-activation': typeof AccountActivationRoute
  '/login': typeof LoginRoute
  '/reset': typeof ResetRoute
  '/$': typeof ProtectedSplatRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/my-profile': typeof ProtectedMyProfileRoute
  '/notifications': typeof ProtectedNotificationsRoute
  '/$/$id': typeof ProtectedSplatIdRoute
  '/$/add': typeof ProtectedSplatAddRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-activation': typeof AccountActivationRoute
  '/login': typeof LoginRoute
  '/reset': typeof ResetRoute
  '/$': typeof ProtectedSplatRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/my-profile': typeof ProtectedMyProfileRoute
  '/notifications': typeof ProtectedNotificationsRoute
  '/$/$id': typeof ProtectedSplatIdRoute
  '/$/add': typeof ProtectedSplatAddRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/account-activation': typeof AccountActivationRoute
  '/login': typeof LoginRoute
  '/reset': typeof ResetRoute
  '/_protected/$': typeof ProtectedSplatRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/my-profile': typeof ProtectedMyProfileRoute
  '/_protected/notifications': typeof ProtectedNotificationsRoute
  '/_protected/$/$id': typeof ProtectedSplatIdRoute
  '/_protected/$/add': typeof ProtectedSplatAddRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-activation'
    | '/login'
    | '/reset'
    | '/$'
    | '/dashboard'
    | '/my-profile'
    | '/notifications'
    | '/$/$id'
    | '/$/add'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-activation'
    | '/login'
    | '/reset'
    | '/$'
    | '/dashboard'
    | '/my-profile'
    | '/notifications'
    | '/$/$id'
    | '/$/add'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/account-activation'
    | '/login'
    | '/reset'
    | '/_protected/$'
    | '/_protected/dashboard'
    | '/_protected/my-profile'
    | '/_protected/notifications'
    | '/_protected/$/$id'
    | '/_protected/$/add'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AccountActivationRoute: typeof AccountActivationRoute
  LoginRoute: typeof LoginRoute
  ResetRoute: typeof ResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-activation': {
      id: '/account-activation'
      path: '/account-activation'
      fullPath: '/account-activation'
      preLoaderRoute: typeof AccountActivationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/$': {
      id: '/_protected/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof ProtectedSplatRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/my-profile': {
      id: '/_protected/my-profile'
      path: '/my-profile'
      fullPath: '/my-profile'
      preLoaderRoute: typeof ProtectedMyProfileRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/notifications': {
      id: '/_protected/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof ProtectedNotificationsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$/$id': {
      id: '/_protected/$/$id'
      path: '/$id'
      fullPath: '/$/$id'
      preLoaderRoute: typeof ProtectedSplatIdRouteImport
      parentRoute: typeof ProtectedSplatRoute
    }
    '/_protected/$/add': {
      id: '/_protected/$/add'
      path: '/add'
      fullPath: '/$/add'
      preLoaderRoute: typeof ProtectedSplatAddRouteImport
      parentRoute: typeof ProtectedSplatRoute
    }
  }
}

interface ProtectedSplatRouteChildren {
  ProtectedSplatIdRoute: typeof ProtectedSplatIdRoute
  ProtectedSplatAddRoute: typeof ProtectedSplatAddRoute
}

const ProtectedSplatRouteChildren: ProtectedSplatRouteChildren = {
  ProtectedSplatIdRoute: ProtectedSplatIdRoute,
  ProtectedSplatAddRoute: ProtectedSplatAddRoute,
}

const ProtectedSplatRouteWithChildren = ProtectedSplatRoute._addFileChildren(
  ProtectedSplatRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedSplatRoute: typeof ProtectedSplatRouteWithChildren
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedMyProfileRoute: typeof ProtectedMyProfileRoute
  ProtectedNotificationsRoute: typeof ProtectedNotificationsRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedSplatRoute: ProtectedSplatRouteWithChildren,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedMyProfileRoute: ProtectedMyProfileRoute,
  ProtectedNotificationsRoute: ProtectedNotificationsRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  AccountActivationRoute: AccountActivationRoute,
  LoginRoute: LoginRoute,
  ResetRoute: ResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
